import React, { useState } from 'react';

export default () => {
  let [lightBox, setLightBox] = useState(false);
  let [lightBoxContent, setLightBoxContent] = useState(null);

  let handleLightBox = (content = false) => {
    if (!lightBox) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.removeProperty('overflow');
    }

    setLightBox(!lightBox);
    if (content) {
      setLightBoxContent(content);
    }
  };

  return { lightBox, handleLightBox, lightBoxContent };
};
